// src/helpers/factories/menu/cardFactories/items/menuItemsLinkedModifierItemsFactory.ts
var menuItemsLinkedModifierItemsFactory = (linkedModifierItems, modifierItems, itemName) => Object.values(linkedModifierItems).map((linkedModifierItem) => {
  var _a, _b;
  return {
    title: ((_a = modifierItems[linkedModifierItem.modifierItemId]) == null ? void 0 : _a.name) || itemName,
    id: linkedModifierItem.modifierItemId,
    modifierItemId: linkedModifierItem.modifierItemId,
    isActive: ((_b = modifierItems[linkedModifierItem.modifierItemId]) == null ? void 0 : _b.active) ? true : false
  };
});

export { menuItemsLinkedModifierItemsFactory };
